export const HttpCoreRoutes = {
  LOGIN: "/login",
  GET_MY_CAMPAIGNS: "/getMyCampaigns",
  PATCH_MY_USER_FIELDS: "/updateMyUserField",
  PATCH_MY_PASSWORD: "/updatePassword",
};
